import { useMemo, useState } from 'react'
import { useAppearanceTheme } from '@/theme/AppThemeProvider'
import { getPrimaryNavAccountMenuItems } from './primaryNavAccountMenuConfig'

export function usePrimaryNavAccountMenu({ onInteract, onAccountMenuAction }) {
  const { resolvedMode } = useAppearanceTheme()
  const [accountMenuAnchor, setAccountMenuAnchor] = useState(null)
  const accountMenuOpen = Boolean(accountMenuAnchor)
  const accountMenuItems = useMemo(() => getPrimaryNavAccountMenuItems(resolvedMode), [resolvedMode])

  const handleAccountMenuOpen = (event) => {
    onInteract?.()
    setAccountMenuAnchor(event.currentTarget)
  }

  const handleAccountMenuClose = () => {
    setAccountMenuAnchor(null)
  }

  const handleAccountItemSelect = (id) => {
    handleAccountMenuClose()
    onAccountMenuAction?.(id)
  }

  return {
    accountMenuAnchor,
    accountMenuOpen,
    accountMenuItems,
    handleAccountMenuOpen,
    handleAccountMenuClose,
    handleAccountItemSelect,
  }
}
